import api from './api';

export const registerAutoRenew = async ({
  paymentMethodId,
  paymentInstrument,
}) => {
  try {
    const response = await api({
      method: 'POST',
      url: '/auto-renew/user',
      data: { paymentMethodId, paymentInstrument },
    });
    return response;
  } catch (err) {
    return err.response?.data;
  }
};

export const getSubscriptionInfo = async (purchaseId) => {
  try {
    const response = await api({
      method: 'GET',
      url: '/auto-renew/user',
      params: { purchaseId },
    });
    return response;
  } catch (err) {
    return err.response?.data;
  }
};

export const cancelSubscription = async () => {
  try {
    const response = await api({
      method: 'POST',
      url: '/auto-renew/cancel',
    });
    return response;
  } catch (err) {
    return err.response?.data;
  }
};

export const pauseAutoRenew = async ({
  cancelReason,
  cancelReasonOther,
  cancelFeedback,
} = {}) => {
  try {
    const response = await api({
      method: 'POST',
      url: '/auto-renew/pause',
      data: { cancelReason, cancelReasonOther, cancelFeedback },
    });
    return response;
  } catch (err) {
    return err.response?.data;
  }
};

export const resumeAutoRenew = async ({
  paymentMethodId,
  paymentInstrument,
}) => {
  try {
    const response = await api({
      method: 'POST',
      url: '/auto-renew/resume',
      data: { paymentMethodId, paymentInstrument },
    });
    return response;
  } catch (err) {
    return err.response?.data;
  }
};

export const getUsageStats = async () => {
  try {
    const response = await api({
      method: 'GET',
      url: '/me/usage-stats',
    });
    return response;
  } catch (err) {
    return err.response?.data;
  }
};
